<ng-container *ngIf="menuService.hasMenu()">
  <div class="container">
    <div id="menu-vital" class="logo-aut-header-govco">
      <div class="row mt-4 w-100">
        <div class="col-md-6 text-start">
          <a title="Ministerio de Ambiente y Desarrollo Sostenible"
            aria-label="Ir al Portal MinAmbiente" alt="Logo Vital" class="navbar-brand">
            <figure class="logo"><img src="../../../../assets/images/logo-vital2.png" alt="Logo Vital"
                title="Ministerio de Ambiente y Desarrollo Sostenible" class="logo-menu-vital"></figure>
            <h1 class="page-title"><span style="letter-spacing: 0px;">ventanilla integral de </span><span
                style="letter-spacing: 1px;"><strong>trámites ambientales</strong></span></h1>
          </a>
        </div>
        <div class="col-md-6 text-end">
          <a class="navbar-brand brand-min-amb" title="Ministerio de Ambiente y Desarrollo Sostenible"
            aria-label="Ir al Portal MinAmbiente" alt="Logo MinAmbiente">
            <img class="logo-menu-minAmb" src="../../../../assets/images/LOGO_AMBIENTE_2023_02.png" alt="Logo MinAmbiente"
              title="Ministerio de Ambiente y Desarrollo Sostenible" lazyLoadImage />
          </a>
        </div>
      </div>
    </div> 
  </div>
  
  <div class="container-navbar-menu-govco lime-green-menu-govco">
    <nav class="container navbar navbar-expand-lg navbar-menu-govco" role="navigation" aria-label="Menú ejemplo entidad">
      <div class="container container-second-navbar-menu-govco">
        <a class="navbar-brand-mobile navbar-toggler" title="Ministerio de Ambiente y Desarrollo Sostenible"
          aria-label="Ir al Portal MinAmbiente" alt="Logo Vital">
          <img class="logo-menu-vital" src="../../../../assets/images/logo-vital2.png" alt="Logo Vital"
            title="Ministerio de Ambiente y Desarrollo Sostenible" lazyLoadImage />
        </a>
        <button class="navbar-toggler button-responsive-menu-govco collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarNavMinAmb" aria-controls="navbarNavMinAmb" aria-expanded="false"
          aria-label="Toggle navigation" #btnCollapsed>
          <span class="icon-bars-menu-govco"></span>
        </button>
  
        <div class="collapse navbar-collapse navbar-collapse-menu-govco" id="navbarNavMinAmb">
          <ul class="navbar-nav navbar-nav-menu-govco m-0">
            <li class="nav-item" *ngFor="let item of menu" [ngClass]="returnClassList(item)" [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }">
              <ng-container *ngIf="item.children.length > 0; else tmplMegaMenu">
                <a *ngIf="item.visible" class="nav-link" [id]="'dropdown-menu-nav'+item.id" role="button"
                  data-bs-toggle="dropdown" aria-expanded="false" aria-current="page">
                  <span class="container-text-icon-menu-govco">
                    <span class="text-item-menu-govco">{{item?.nombre}}</span>
                    <span class="icon-caret-menu-govco"></span>
                  </span>
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown" [id]="'dropdown-menu-'+item.id">
                  <li class="text-start" *ngFor="let itemChildren of item.children">
                    <ng-container *ngIf="itemChildren.urlHref; else tmplRouterLink">
                      <a *ngIf="itemChildren.visible" class="dropdown-item dir-menu-govco"
                        (click)="comprobarOpcion(itemChildren)">{{itemChildren.nombre}}</a>
                    </ng-container>
                    <ng-template #tmplRouterLink>
                      <a *ngIf="itemChildren.visible" class="dropdown-item dir-menu-govco"
                        [routerLink]="itemChildren.routerLink" [queryParams]="{ rep: itemChildren.queryParams }"
                        (click)="itemSeleccionadoReporte(item?.id, false)">{{itemChildren.nombre}}</a>
                    </ng-template>
                  </li>
                </ul>
              </ng-container>
  
              <ng-template #tmplMegaMenu>
                <ng-container *ngIf="item.megaMenu === true; else tmplNormalLink">
                  <a *ngIf="item.visible" class="nav-link" [id]="'dropdown-menu-nav'+item.id" role="button"
                    data-bs-toggle="dropdown" aria-expanded="false" aria-current="page">
                    <span class="container-text-icon-menu-govco">
                      <span class="text-item-menu-govco">{{item?.nombre}}</span>
                      <span class="icon-caret-menu-govco"></span>
                    </span>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end megamenu-menu-govco" role="menu">
                    <div class="g-3 container-items-govco">
                      <div *ngFor="let itemSeccion of item.secciones" class="colum-item-menu-govco">
                        <span class="title">{{itemSeccion.nombreSeccion}}</span>
                        <hr class="dropdown-divider">
                        <ul class="list-unstyled" [id]="'dropdown-menu-seccion-'+itemSeccion.id">
                          <li *ngFor="let seccionChildren of itemSeccion.children">
                            <a class="dropdown-item dir-menu-govco" [routerLink]="seccionChildren.routerLink"
                              [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }"
                              (click)="itemSeleccionadoReporte(itemSeccion?.id, true)">{{seccionChildren.nombre}}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #tmplNormalLink>
                  <a *ngIf="item.visible" class="nav-link dir-menu-govco" [routerLink]="item.url" (click)="itemSeleccionadoReporte(item?.id, false)"
                    [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" aria-current="page">
                    <span class="text-item-menu-govco"> {{item?.nombre}} </span>
                  </a>
                </ng-template>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</ng-container>  
    <!-- TODO: No eliminarlo, después se debe utilizar cuando el SSO este listo -->
  <wecmp-sso-login texto="Sistema de autenticación del Ministerio de Ambiente y Desarrollo Sostenible" 
    [attr.url-key-cloak]="urlKeycloak" 
    (tokenResolved)="getToken($event.detail)"
    (userInfoResolved)="getUserInfo($event.detail)"
    (urlLogOut)="getUrlLogOut($event.detail)"
    [attr.realm-key-cloak]="realmKeycloak" 
    [attr.client-id-key-cloak]="clientIdKeycloak" 
    [is-fluid]="false" 
    [required-login-start]="false"
    [aditionalParams]="'kc_idp_hint=scd-auth'"
    [updateTokenNumber]="tokenNumber"
    [timeToRefreshToken]="refreshTime" 
    [urlInfo]="urlInfo"
    [closeSesion]="closeUserSession"
    [hideBtnEdit]="menuService.isHideOptionsEditAccount()">
  </wecmp-sso-login> 
  
    <!-- [aditionalParams]="'kc_idp_hint=scd-auth'"
         [url-account]="urlAccount" 
         [closeSesion]="closeUserSession"  [hideBtnSesion]="true"-->
    <!--<div class="contenedor-login"  [ngClass]="{'oculto': !activarVitalAnteriror}">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <div class="mensaje">
                <span class="govco-info-circle"></span> Encuentra y gestiona tus trámites y servicios ambientales en VITAL
              </div>
            </div>
            <div class="col-md-4">
              <div class="perfil">
                <div class="info-user text-center">  
                  <button
                    type="button"
                    class="btn-govco outline-btn-govco underline-btn"
                    (click)="redirectTo(urlSilpa)"
                  >
                    Iniciar sesión
                  </button>
  
                  <button
                    type="button"
                    class="btn-govco outline-btn-govco ms-3"
                    (click)="redirectTo(urlSilpaRegistro)"
                  >
                    Registrarse
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  -->
  
      <div class="container" *ngIf="mostrar_modal">
        <wecmp-transversales-info-modal 
            [open]="mostrar_modal" 
            [mensajeAlerta]="mensajeAuthRequerida"
            (onClosedModal)="onCloseModal()"
            [isClassGovco]="true"
            [canCloseBackdrop]="false">
        </wecmp-transversales-info-modal>
      </div>
  
      <div class="container" *ngIf="complete_registro">
        <wecmp-transversales-info-modal 
            [open]="complete_registro" 
            [mensajeAlerta]="mensajeCompleteRegistro"
            (onClosedModal)="onCloseModalCompleteRegistro()"
            [isClassGovco]="true"
            [canCloseBackdrop]="false">
        </wecmp-transversales-info-modal>
      </div>

